// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const EnterIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="EnterIcon" ref={forwardedRef} {...props}>
      <path d="M2 10.757 6.243 15l1.06-1.06-2.439-2.44H17a1 1 0 0 0 1-1v-4h-1.5V10H4.879l2.424-2.425-1.06-1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const EnterIcon = /* @__PURE__ */ Object.assign(EnterIconComponent, {
  displayName: 'EnterIcon',
});
